import script from "./SheetSong.vue?vue&type=script&lang=ts&setup=true"
export * from "./SheetSong.vue?vue&type=script&lang=ts&setup=true"

import "./SheetSong.vue?vue&type=style&index=0&id=54e1c848&lang=scss&scoped=true"
script.__scopeId = "data-v-54e1c848"

export default script